export default "__VITE_ASSET__lO$sftNB__"